// extracted by mini-css-extract-plugin
module.exports = {"mainNav":"main-nav-module--main-nav--3ZXvb","link":"main-nav-module--link--1xqOo","linkActive":"main-nav-module--link-active--1aAzI","mobile":"main-nav-module--mobile--39Haz"};